module.exports = __webpack_public_path__ + "img/whatsapp.2a203d4a.svg";